import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'value-averaging-terms',
        name: routeName.VALUE_AVERAGING_TERMS,
        component: () => import('@/views/aplCatl640and631/A4/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '定期定額投資金額申請/變更說明', leaveAlert: true, code: 'A4', unableBack: true },
    },
    {
        path: 'value-averaging',
        name: routeName.VALUE_AVERAGING,
        component: () => import('@/views/aplCatl640and631/A4/valueAveraging/Index.vue'),
        meta: { auth: true, metaTitle: '定期定額投資金額申請/變更', leaveAlert: true, code: 'A4', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.VALUE_AVERAGING_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
